// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bBVqjTBNlAmnmk {
  position: relative;
  bottom: var(--ds-space-400, 32px);
  left: var(--ds-space-400, 32px);
}
@media only screen and (max-width: 600px) {
  .bBVqjTBNlAmnmk {
    bottom: var(--ds-space-0, 0);
    left: var(--ds-space-0, 0);
  }
}
.N4L3M7nBJUpplx {
  position: absolute;
  bottom: var(--ds-space-0, 0);
  width: calc(var(--ds-space-100, 8px) * 50);
  transition: transform 400ms ease-in-out;
}
@media (max-width: 560px) {
  .N4L3M7nBJUpplx {
    width: 100vw;
  }
}
.N4L3M7nBJUpplx:first-of-type {
  transform: translate(0, 0);
  transition: none;
}
.N4L3M7nBJUpplx:nth-of-type(n + 2) {
  transform: translateX(0) translateY(100%) translateY(16px);
  animation-duration: 0ms;
}
.N4L3M7nBJUpplx:nth-of-type(1) {
  z-index: 5;
}
.N4L3M7nBJUpplx:nth-of-type(2) {
  z-index: 4;
}
.N4L3M7nBJUpplx:nth-of-type(n + 4) {
  visibility: hidden;
}
.aFMxIDv9mXuicr:nth-of-type(n + 2) {
  transform: translate(0, 0);
  transition-duration: 200ms;
}
.nwypo2qD6rZt6X {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: var(--ds-space-0, 0);
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  border: 0;
  white-space: nowrap;
}
.bfb0aNnc3caWwf {
  z-index: 600;
  box-sizing: border-box;
  width: 100%;
  padding: var(--ds-space-200, 16px);
  transition: background-color 200ms;
  border-radius: var(--ds-radius-small, 4px);
  background-color: var(--ds-surface-overlay, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
}
.bfb0aNnc3caWwf:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--ds-border-focused, #388bff);
}
.SbOOLZUl7qN8OB {
  display: flex;
  align-items: center;
  min-height: var(--ds-space-400, 32px);
  gap: var(--ds-space-200, 16px);
}
.uKXj60roUsqu1F {
  flex: 0 0 24px;
  text-align: center;
}
.VmbXKMJLSqfD0U {
  flex: 1;
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-semibold, 600);
  word-break: break-word;
}
.F9EOc0_yHVJ11x {
  flex: 0 0 auto;
  margin-left: var(--ds-space-100, 8px);
  padding: var(--ds-space-0, 0);
  border: none;
  border-radius: var(--ds-radius-small, 3px);
  background: none;
  color: var(--ds-text, #172b4d);
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  appearance: none;
}
.F9EOc0_yHVJ11x:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--ds-border-focused, #388bff);
}
.H9qoSsTIAHtpeN,
.s__Keue9O2Rq72 {
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding-left: var(--ds-space-500, 40px);
}
.s__Keue9O2Rq72 {
  margin-top: var(--ds-space-050, 4px);
}
.K6yhPZSqLqscFV {
  overflow: auto;
  color: var(--ds-text, #172b4d);
  word-wrap: break-word;
}
.uirNm7MHGFvZsK {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.lh1bSlakqhcARO {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-top: var(--ds-space-100, 8px);
  transform: translateX(var(--ds-space-negative-025, -2px));
}
.nIR34Gm890iRpH {
  color: var(--ds-link, #0c66e4);
  font-weight: var(--ds-font-weight-medium, 500);
  cursor: pointer;
}
.nIR34Gm890iRpH:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .nIR34Gm890iRpH:focus {
  outline-color: -webkit-focus-ring-color;
}
.nIR34Gm890iRpH:focus .mac.firefox {
  outline-color: AccentColor;
}
.nIR34Gm890iRpH:hover {
  color: var(--ds-link, #0c66e4);
  text-decoration: underline;
}
.Cvlt62YxWHJHWG {
  display: inline-block;
  width: var(--ds-space-200, 16px);
  text-align: center;
}
.Ak_Mbn6W1rS8Dr {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  line-height: 1;
  vertical-align: bottom;
}
`, ""]);
// Exports
export var flagGroup = `bBVqjTBNlAmnmk`;
export var flagGroupChildren = `N4L3M7nBJUpplx`;
export var dismissAllowed = `aFMxIDv9mXuicr`;
export var flagGroupLabel = `nwypo2qD6rZt6X`;
export var flag = `bfb0aNnc3caWwf`;
export var header = `SbOOLZUl7qN8OB`;
export var icon = `uKXj60roUsqu1F`;
export var title = `VmbXKMJLSqfD0U`;
export var dismissButton = `F9EOc0_yHVJ11x`;
export var expander = `H9qoSsTIAHtpeN`;
export var descriptionExpander = `s__Keue9O2Rq72`;
export var description = `K6yhPZSqLqscFV`;
export var truncateDescription = `uirNm7MHGFvZsK`;
export var actions = `lh1bSlakqhcARO`;
export var actionLink = `nIR34Gm890iRpH`;
export var actionSeparator = `Cvlt62YxWHJHWG`;
export var imageIcon = `Ak_Mbn6W1rS8Dr`;
export default ___CSS_LOADER_EXPORT___;
